import * as React from "react";

export function PrincipleInactionIllustration(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 800 450" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
      <defs>
        <filter id="dsosGlow2" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="6" result="blur" />
          <feFlood floodColor="hsl(var(--primary))" floodOpacity="0.28" result="flood" />
          <feComposite in="flood" in2="blur" operator="in" result="glow" />
          <feMerge>
            <feMergeNode in="glow" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <rect
        x="40"
        y="40"
        width="720"
        height="370"
        rx="24"
        fill="hsl(var(--card))"
        stroke="hsl(var(--border))"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
      />

      {/* timeline */}
      <path
        d="M110 210 H690"
        stroke="hsl(var(--border))"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
      />

      {/* checkpoints */}
      {[170, 310, 450, 590].map((x, i) => (
        <g key={i}>
          <circle cx={x} cy={210} r="10" fill="hsl(var(--card))" stroke="hsl(var(--border))" strokeWidth="1.5" vectorEffect="non-scaling-stroke" />
          <circle cx={x} cy={210} r="3" fill="hsl(var(--muted-foreground))" />
        </g>
      ))}

      {/* 24h marker */}
      <path d="M520 188 V232" stroke="hsl(var(--primary))" strokeWidth="1.5" vectorEffect="non-scaling-stroke" />
      <rect
        x="494"
        y="150"
        width="52"
        height="26"
        rx="13"
        fill="hsl(var(--primary) / 0.12)"
        stroke="hsl(var(--primary))"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
      />
      <text x="520" y="168" fontSize="12" fontWeight="900" textAnchor="middle" fill="hsl(var(--primary))">
        24h
      </text>

      {/* alert triangle */}
      <path
        d="M665 190 L690 234 H640 Z"
        fill="hsl(var(--card))"
        stroke="hsl(var(--primary))"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
      />
      <path d="M665 205 V220" stroke="hsl(var(--primary))" strokeWidth="1.5" vectorEffect="non-scaling-stroke" />
      <circle cx="665" cy="226" r="2.5" fill="hsl(var(--primary))" />

      {/* escalated card */}
      <g filter="url(#dsosGlow2)">
        <rect
          x="150"
          y="265"
          width="500"
          height="120"
          rx="22"
          fill="hsl(var(--card))"
          stroke="hsl(var(--primary))"
          strokeWidth="1.5"
          vectorEffect="non-scaling-stroke"
        />
      </g>
      <text x="180" y="305" fontSize="16" fontWeight="900" fill="hsl(var(--foreground))">
        No contact → escalated to Today
      </text>
      <text x="180" y="333" fontSize="12" fontWeight="700" fill="hsl(var(--muted-foreground))">
        Auto-triggered when inactivity crosses the threshold.
      </text>
      <text x="180" y="356" fontSize="12" fontWeight="700" fill="hsl(var(--muted-foreground))">
        Missed actions surface before revenue is lost.
      </text>

      {/* subtle badge on card right */}
      <rect
        x="540"
        y="292"
        width="90"
        height="30"
        rx="15"
        fill="hsl(var(--primary) / 0.12)"
        stroke="hsl(var(--primary))"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
      />
      <text x="585" y="312" fontSize="12" fontWeight="900" textAnchor="middle" fill="hsl(var(--primary))">
        Alert
      </text>
    </svg>
  );
}
